var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKomps(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M10.916.938c.553 0 1 .46 1 1.028v4.077H9.809V.937h1.108zm-1.108 7.5V6.566h2.109v.844c0 .567-.448 1.027-1 1.027h-1.11zM1.424.938h7.84v7.5H1.331a.496.496 0 0 1-.414-.446V1.387a.496.496 0 0 1 .441-.45h.066z",
    id: "a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.916.938c.553 0 1 .46 1 1.028v4.077H9.809V.937h1.108zm-1.108 7.5V6.566h2.109v.844c0 .567-.448 1.027-1 1.027h-1.11zM1.424.938h7.84v7.5H1.331a.496.496 0 0 1-.414-.446V1.387a.496.496 0 0 1 .441-.45h.066z",
    id: "b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.916.938c.553 0 1 .46 1 1.028v4.077H9.809V.937h1.108zm-1.108 7.5V6.566h2.109v.844c0 .567-.448 1.027-1 1.027h-1.11zM1.424.938h7.84v7.5H1.331a.496.496 0 0 1-.414-.446V1.387a.496.496 0 0 1 .441-.45h.066z",
    id: "c"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.417 .5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.222 0h9.167a2.444 2.444 0 0 1 2.444 2.444v4.487a2.444 2.444 0 0 1-2.444 2.444H1.222A1.222 1.222 0 0 1 0 8.153v-6.93C0 .546.547 0 1.222 0z",
    fill: "#FFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#404041",
    className: "colorize",
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.583 3.313)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.222 0h9.167a2.444 2.444 0 0 1 2.444 2.444v4.487a2.444 2.444 0 0 1-2.444 2.444H1.222A1.222 1.222 0 0 1 0 8.153v-6.93C0 .546.547 0 1.222 0z",
    fill: "#FFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#404041",
    className: "colorize",
    xlinkHref: "#b"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(.75 6.125)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.222 0h9.167a2.444 2.444 0 0 1 2.444 2.444v4.487a2.444 2.444 0 0 1-2.444 2.444H1.222A1.222 1.222 0 0 1 0 8.153v-6.93C0 .546.547 0 1.222 0z",
    fill: "#FFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#404041",
    className: "colorize",
    xlinkHref: "#c"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKomps);
export default __webpack_public_path__ + "static/media/komps.73f30d52b6a7fa0e666e21c195a90a1b.svg";
export { ForwardRef as ReactComponent };